import { get, post, put } from 'api/request';
import urls from 'configs/urls';

export const getServiceCatalog = queryString =>
  get(null, false, `${urls.labsModuleUrls.masterList.getAllServices}?${queryString}`);

export const addService = data =>
  post(null, false, urls.labsModuleUrls.masterList.addService, data);

export const editService = (serviceKey, data) =>
  put(null, false, `${urls.labsModuleUrls.masterList.editService}/${serviceKey}`, data);
